/**
 * Role-based access control — the single source of truth.
 * Both the API (enforcement) and the web app (UI gating) import from here.
 * See docs/03-roles-and-permissions.md for the rationale behind every entry.
 */
export const Role = {
    /** Administratori i sistemit — full control, manages users and reference data. */
    SUPER_ADMIN: 'SUPER_ADMIN',
    /** Drejtuesit e lartë (p.sh. Sekretari i Përgjithshëm): see everything, create their own activities anywhere. */
    LEADERSHIP: 'LEADERSHIP',
    /** Deputetët dhe Anëtarët e Kryesisë — create activities in any county/municipality. */
    MP_EXECUTIVE: 'MP_EXECUTIVE',
    /** Kryetarët e Degëve — create activities only within their assigned branch. */
    BRANCH_CHAIR: 'BRANCH_CHAIR',
};
export const ROLES = Object.values(Role);
export const Permission = {
    ACTIVITY_CREATE: 'activity:create',
    ACTIVITY_UPDATE_OWN: 'activity:update:own',
    ACTIVITY_UPDATE_ANY: 'activity:update:any',
    ACTIVITY_DELETE_OWN: 'activity:delete:own',
    ACTIVITY_DELETE_ANY: 'activity:delete:any',
    ACTIVITY_READ_OWN: 'activity:read:own',
    ACTIVITY_READ_ALL: 'activity:read:all',
    /** Choose any county / municipality when creating an activity. */
    ACTIVITY_CHOOSE_LOCATION: 'activity:choose-location',
    DASHBOARD_VIEW: 'dashboard:view',
    USER_MANAGE: 'user:manage',
    REFERENCE_DATA_MANAGE: 'reference-data:manage',
    AUDIT_VIEW: 'audit:view',
    /** Send an announcement to many people, in the app and optionally by e-mail. */
    ANNOUNCEMENT_SEND: 'announcement:send',
    /** Set the political message of the week (Mesazhet e javës). */
    MESSAGE_MANAGE: 'message:manage',
};
const P = Permission;
export const ROLE_PERMISSIONS = {
    SUPER_ADMIN: Object.values(P),
    LEADERSHIP: [
        P.ACTIVITY_READ_ALL,
        P.ACTIVITY_READ_OWN,
        P.DASHBOARD_VIEW,
        P.ANNOUNCEMENT_SEND,
        P.MESSAGE_MANAGE,
        // Leadership also organises activities (product owner, 2026-09-19): same rights as MPs
        // over their own activities, in any location. They cannot edit other people's.
        P.ACTIVITY_CREATE,
        P.ACTIVITY_UPDATE_OWN,
        P.ACTIVITY_DELETE_OWN,
        P.ACTIVITY_CHOOSE_LOCATION,
    ],
    MP_EXECUTIVE: [
        P.ACTIVITY_CREATE,
        P.ACTIVITY_UPDATE_OWN,
        P.ACTIVITY_DELETE_OWN,
        P.ACTIVITY_READ_OWN,
        P.ACTIVITY_CHOOSE_LOCATION,
    ],
    BRANCH_CHAIR: [
        P.ACTIVITY_CREATE,
        P.ACTIVITY_UPDATE_OWN,
        P.ACTIVITY_DELETE_OWN,
        P.ACTIVITY_READ_OWN,
    ],
};
export function hasPermission(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
/** Roles whose accounts must be bound to a single branch / administrative unit. */
export const ROLES_WITH_FIXED_LOCATION = [Role.BRANCH_CHAIR];
//# sourceMappingURL=roles.js.map